import { render } from "./optional-filter-section-tuition-fee.vue?vue&type=template&id=aedd25d8&ts=true"
import script from "./optional-filter-section-tuition-fee.ts?vue&type=script&lang=ts&external"
export * from "./optional-filter-section-tuition-fee.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__